import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const ItemContainer = styled.div({
  display: 'flex',
  flex: 1,
  paddingRight: '0px',
  overflowX: 'scroll',

  '@media only screen and (min-width: 600px)': {
    paddingRight: '0.9375rem',
    overflowX: 'scroll',
  },

  '@media only screen and (min-width: 769px)': {
    paddingRight: '0.9375rem',
    overflowX: 'unset',
  },
})

export const Cont = styled.div({
  display: 'flex',
  flexDirection: 'column',
  border: '1px solid rgba(34,36,38,.15)',
  flex: 1,

  '.itemActive':{
    background:v.borderBlueGray
  }
});

export const THeader = styled.div({
  display: 'flex',
  background: `${v.ezGrayColor}`,
  minHeight:'3rem',
  maxWidth:'100%',
  fontWeight:'bold',
  
  '>div':{
    flex:1,
    display:'flex',
    justifyContent:'center',
    textAlign: 'center',
    alignItems:'center',
    borderRight:'1px solid rgba(34,36,38,.15)',
    borderBottom:'1px solid rgba(34,36,38,.15)',
  },

  '>div:last-child':{
    borderRight:'none'
  }
});

export const TBody = styled.div({
  display: 'flex',
  minHeight:'2rem',
  maxWidth:'100%',
  
  '>div':{
    flex:1,
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    borderRight:'1px solid rgba(34,36,38,.15)',
    borderBottom:'1px solid rgba(34,36,38,.15)',
  },

  '.colPRRef':{
    cursor:'pointer',
    textDecoration: 'underline',
    color: '#FBBF66'
  },
  
  '.colPRRef:hover':{
    color:'#000',
    fontWeight:'bold'
  },

  '>div:last-child':{
    borderRight:'none'
  },

  '.left':{
    justifyContent:'flex-start',
    paddingLeft:'0.2rem'
  },

  '.right':{
    justifyContent:'flex-end',
    paddingRight:'0.2rem'
  },

  '.fieldData':{
    paddingRight:0,
    '>div':{
      marginRight:0,
      maxWidth:'100%',
      minHeight:'100%'
    },
    '.fieldRow':{
      marginBottom:0
    },
    'input':{
      padding:'0.01rem'
    }
  },

  '.itemName':{
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    overflow: 'hidden',
  },

  '.minusData':{
    'input':{
      color:'red !important'
    },
  },

  '@media only screen and (min-width: 600px)': {
    '.itemName':{
      whiteSpace: 'nowrap',
    },
  },

  '@media only screen and (min-width: 769px)': {
    '.itemName':{
      whiteSpace: 'nowrap',
    },
  },
});

export const THPage = styled.div({
  display: 'flex',
  justifyContent:'center',
  alignItems:'center',
  padding:'0.5rem',
  borderBottom:'1px solid rgba(34,36,38,.15)',
});

export const TFooter = styled.div({
  display: 'flex',
  maxWidth:'100%',
  flexDirection: 'column',

  '.row':{
    display:'flex',
    minHeight:'3rem',
    maxWidth:'100%',
    // borderBottom:'1px solid rgba(34,36,38,.15)',
  },
  
  '.title':{
    display:'flex',
    alignItems:'center',
    justifyContent:'flex-end',
    textAlign:'right',
    minWidth:'89%',
    paddingRight:'0.2rem',
    borderRight:'1px solid rgba(34,36,38,.15)',
  },
  
  '.data':{
    display:'flex',
    alignItems:'center',
    justifyContent:'flex-end',
    textAlign:'right',
    minWidth:'11%',
    paddingRight:'0.2rem',
  },

  '.fieldData':{
    paddingRight:0,

    '.dataField':{
      marginRight:0,
      maxWidth:'100%',
      marginLeft:'0.1rem',

      'input':{
        paddingLeft:'0.2rem',
        paddingRight:'0.2rem'
      }
    },

    '.ui.selection.dropdown':{
      minHeight:'auto',
      padding:'0.6rem',

      'i':{
        padding:'0.6rem'
      }
    },

    '>div':{
      marginRight:0,
      maxWidth:'20%',
      marginLeft:'0.1rem'
    },

    '.fieldRow':{
      marginBottom:0
    },

    'input':{
      padding:'0.5rem'
    }
  },

  '.minusData':{
    color:'red !important',
    'input':{
      color:'red !important'
    },
  }
});

